import campaignMonitor from './campaignMonitorAuth.component';
import campaignMonitorAutoSync from './campaignMonitorAutoSync.component';

export default angular
  .module('st.Integrations.CampaignMonitor', [])
  .component('campaignMonitor', campaignMonitor)
  .component('campaignMonitorAutoSync', campaignMonitorAutoSync)
  .service('campaignMonitorService', ($q, $http, dataService, CAMPAIGN_MONITOR) => ({
    listAddTo: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CAMPAIGN_MONITOR.API.LIST_ADD_TO,
        { params },
        null,
        true
      ),
    listCreate: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CAMPAIGN_MONITOR.API.LIST_CREATE,
        { params },
        null,
        true
      ),
    lists: () =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CAMPAIGN_MONITOR.API.LISTS,
        {},
        null,
        true
      ),
    sso: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CAMPAIGN_MONITOR.API.SSO,
        {
          params
        },
        null,
        true
      ),
    sync: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CAMPAIGN_MONITOR.API.SYNC,
        {
          params
        },
        null,
        true
      )
  }))
  .constant('CAMPAIGN_MONITOR', {
    API: {
      LIST_ADD_TO: '/api/v1/integration/campaignMonitor/list-add-to',
      LIST_CREATE: '/api/v1/integration/campaignMonitor/list-create',
      LISTS: '/api/v1/integration/campaignMonitor/lists',
      SSO: '/api/v1/integration/campaignMonitor/sso',
      SYNC: '/api/v1/integration/campaignMonitor/sync'
    }
  });
